import { DesfechoUltimaGestacaoEnum } from 'graphql/types.generated'
import { isObjectDeepFalsy } from 'util/object'
import { isEmpty } from 'util/validation/Util'

import { FolhaRostoInformacoesObstetricasModel } from './model-antecedentes'

export const isInformacoesObstetricasPreenchidas = (informacoesObstetricas: FolhaRostoInformacoesObstetricasModel) => {
  const { desfechoUltimaGestacao, ...informacoesObstetricasSemPartoMenosDeUmAno } = informacoesObstetricas
  return (
    isDesfechoUltimaGestacaoValido(desfechoUltimaGestacao) ||
    !isObjectDeepFalsy(informacoesObstetricasSemPartoMenosDeUmAno)
  )
}

export const isDesfechoUltimaGestacaoValido = (desfecho: string) => {
  return !isEmpty(desfecho) && desfecho !== DesfechoUltimaGestacaoEnum.NAO_INFORMADO
}
